import swiggy from '../../../assets/star/online/swiggy.svg';
import jiomart from '../../../assets/star/online/jiomart.svg';
import bookmyshow from '../../../assets/star/online/bookmyshow.svg';
import macdonld from '../../../assets/star/online/macdonld.svg';
import netmeds from '../../../assets/star/online/netmeds.svg';
import es from '../../../assets/star/online/es.svg';
import confirmtkt from '../../../assets/star/online/confirmtkt.svg';
import zoomin from '../../../assets/star/online/zoomin.svg';
import indianoil from '../../../assets/star/offline/indianoil.svg';
import dmart from '../../../assets/star/offline/dmart.svg';
import lifestyle from '../../../assets/star/offline/lifestyle.svg';
import pvr from '../../../assets/star/offline/pvr.svg';
import pantaloons from '../../../assets/star/offline/pantaloons.svg';
import pizzahut from '../../../assets/star/offline/pizzahut.svg';
import starbuks from '../../../assets/star/offline/starbuks.svg';
import shopperstop from '../../../assets/star/offline/shopperstop.svg';
import scanner from '../../../assets/star/Hero.png';
import shadedBackGroud from '../../../assets/star/shadedBackGroud.png';
import fivepercent from '../../../assets/star/fivepercent.png';
import TwidStars from '../../../assets/star/TwidStars.png';
import Scanner from '../../../assets/star/Scanner.png';

//
import cash from '../../../assets/star/cash.svg';
import stepScanner from '../../../assets/star/stepScanner.svg';
import store from '../../../assets/star/store.svg';
import star from '../../../assets/star/star.svg';
import saving from '../../../assets/star/saving.svg';
import twidstar from '../../../assets/star/twidstar.svg';
import bank from '../../../assets/star/bank.svg';
import activeuser from '../../../assets/star/users.svg';
import down from '../../../assets/star/down.svg';

export default {
  Scanner,
  TwidStars,
  fivepercent,
  shadedBackGroud,
  scanner,
  indianoil,
  dmart,
  lifestyle,
  pvr,
  pantaloons,
  pizzahut,
  starbuks,
  shopperstop,
  swiggy,
  jiomart,
  bookmyshow,
  macdonld,
  netmeds,
  es,
  confirmtkt,
  zoomin,
  //
  cash,
  stepScanner,
  store,
  star,
  saving,
  twidstar,
  bank,
  activeuser,
  down,
};
